// extracted by css-extract-rspack-plugin
export default {"root":"I6CUtA","title":"ug3ysL","subtitle":"Y9H1Ss","slider":"dr_IoL","custom-spacing":"nslC4n","customSpacing":"nslC4n"};